<template>
  <!-- Old bit.dev component -->
  <transition name="c-base-operation-loading">
    <div v-if="show" class="c-base-operation-loading">
      <div class="c-base-operation-loading__wrapper">
        <BaseLottie :json="withdrawLoadingAnimation" />
        <p class="has-text-white">
          <strong class="has-text-white">
            Estamos enviando a sua solicitação.
          </strong>
        </p>
        <br />
        <p class="has-text-white margin-bottom">Por favor, aguarde...</p>
        <div v-if="isCancelled" class="c-base-operation-loading__footer">
          <button
            @click="cancel"
            type="button"
            class="c-base-operation-loading__button button is-outlined is-white"
          >
            <i class="icon">
              <!-- Use this slot to set icon button -->
              <slot name="icon"> </slot>
            </i>
            {{ buttonLabel }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BaseLottie from '@/components/Wallet/BaseLottie.vue'
import withdrawLoadingAnimation from '@/assets/animations/withdraw-loading.json'

export default {
  props: {
    // Define label to button cancel
    buttonLabel: {
      type: String,
      default: 'Cancelar Solicitação',
    },

    // Defines whether modal is opened or not
    forceShow: {
      type: Boolean,
      default: false,
    },

    // Defines if the operation can be canceled
    isCancelled: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    BaseLottie,
  },

  data() {
    return {
      // Defines whether modal is opened or not
      show: false,
      withdrawLoadingAnimation,
    }
  },

  mounted() {
    if (this.forceShow) this.show = true
  },

  methods: {
    // Open the modal
    open() {
      this.show = true
    },

    // Close the modal
    close() {
      this.show = false
    },

    // Cancel and emit event cancelled
    cancel() {
      this.$emit('cancelled')
      this.show = false
    },
  },
}
</script>

<style lang="scss">
.c-base-operation-loading {
  @include position(fixed, 0, 0, 0, 0);
  z-index: 32;
  text-align: center;
  background-color: $overlay;

  &__button {
    .icon {
      margin: 0 12px 0 0 !important;
    }
  }

  &__wrapper {
    @include position(absolute, 50%, 0, auto, 0, -50%);
    p {
      font-size: 16px;
    }
  }

  &__footer {
    padding-top: 32px;
  }

  // animation
  &-enter-active,
  &-leave-active {
    transition: opacity 0.5s ease-in-out;
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
</style>
